import React from 'react';
import Link from '../components/IntlLink'
import Img from 'gatsby-image'
import humps from "humps"
import logo from '../images/logo_grey.svg'
import { FormattedMessage } from 'react-intl'
import Modal from '../components/Modal'
import RequestDownloadAccess from '../components/RequestDownloadAccess'
import Field from '../components/Field';
import NewsletterForm from '../components/NewsletterForm';
import i18n from '../utils/i18n';

const ListLink = props =>
  <li className="footer__nav__link">
    <Link to={props.to}>
      {props.children}
    </Link>
  </li>

class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.state = { modal: null }
  }

  handleOpenDownloadModal(e) {
    e.preventDefault();
    this.setState({ modal: 'requestInfo' });
  }

  handleCloseModal() {
    this.setState({ modal: null });
  }

  handleSubmit(e) {
    e.preventDefault();
    const data = new FormData(e.target)
    // action="https://app.mailerlite.com/webforms/submit/n0h5i8" data-id="750656" data-code="n0h5i8" method="POST" target="_blank"
  }

  renderDownload() {
    return (
      <li className="footer__nav__link" key="download">
        <a href="#" onClick={(e) => this.handleOpenDownloadModal(e)}>
          Download
        </a>
      </li>
    )
  }

  render() {
    const allData = this.props.data;

    return (
      <div className="footer">
        <div className="wrap">
          {
            this.props.showCta &&
              <div className="footer__cta">
                <p className="footer__title">
                  <FormattedMessage id="footer.cta.title" />
                </p>
                <Link to={`/p/${allData.menuContact.slug}`} className="button--dark button--bigger">
                  <FormattedMessage id="footer.cta.button" />
                </Link>
              </div>
          }
        </div>
        <div className="footer__nav">
          <ul className="footer__nav__inner">
            {
              ['homepage', 'catalog', 'interchangeability', 'projects', 'philosophy', 'designers', 'about', 'news', 'contact', 'download'].map(page => {
                if (page === 'projects') {
                  return (
                    <li className="footer__nav__link" key={page}>
                      <Link to={`/category/projects-and-environments`}>
                        Projects & Environments
                      </Link>
                    </li>
                  );
                } else if (page === 'download') {
                  return(
                    this.renderDownload()
                  )
                } else {
                  const data = allData[humps.camelize(`menu_${page}`)];
                  const to = data.slug ? `/p/${data.slug}` : `/`;
                  return (
                    <ListLink key={page} to={to}>
                      {data.menuTitle}
                    </ListLink>
                  );
                }
              })
            }
          </ul>
        </div>

        <div className="footer__newsletter">
          <div className="wrap">
            <h3 className="footer__newsletter__title">{allData.menuFooter.newsletterTitle}</h3>
            <p className="footer__newsletter__description">{allData.menuFooter.newsletterDescription}</p>
            <NewsletterForm />
          </div>
        </div>

        <div className="footer__logo">
          <img src={logo} />
        </div>
        <div className="footer__contact">
          <div className="wrap">
            <div>
              <a
                href={allData.menuFooter.googleMapsUrl}
                target="_blank"
                dangerouslySetInnerHTML={{ __html: allData.menuFooter.address.markdown.html }}
              />
            </div>

            <p><strong><FormattedMessage id="footer.contact.phoneNumber" /></strong> {allData.menuFooter.phoneNumber}</p>
            <p>{allData.menuFooter.emailAddress}</p>
            <p>{allData.menuFooter.vat}</p>
          </div>
        </div>
        <div className="footer__social">
          {
            ['instagram', 'facebook', 'pinterest', 'twitter', 'youtube', 'vimeo'].map(social => {
              const url = allData.menuFooter[social];

              if (!url) {
                return;
              }

              return (
                <a
                  key={social}
                  href={url}
                  target="_blank"
                  className={`footer__social__item ${social}`}
                />
              );
            })
          }
        </div>
        <div className="footer__footnote">
          <p>All rights reserved {new Date().getFullYear()}</p>
          <strong><a
            className="iubenda-nostyle no-brand iubenda-embed form__strong"
            title="Privacy Policy"
            href={`//www.iubenda.com/privacy-policy/${i18n.t('iubendaId')}`}
            target="_blank"
          >Privacy policy</a></strong>
          <p>Made with ♥ by <a href="http://www.cantierecreativo.net/">Cantiere Creativo</a> using <a href="https://www.datocms.com/">DatoCMS</a></p>
        </div>
        <Modal
          visible={this.state.modal === 'requestInfo'}
          onClose={() => this.handleCloseModal()}
        >
          <RequestDownloadAccess
            productUrl='/download'
            onSubmit={() => this.handleCloseModal()}
          />
        </Modal>
      </div>
    );
  }
}

Footer.defaultProps = {
  showCta: true,
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js